<div class="curation-match">
    <div class="curation-match-background"></div>
    <span class="curation-match-text">{{itemKey}}</span>
    <span *ngIf="itemType != null && itemType !=''"  class="curation-match-text">{{itemType}}</span>
    <span class="curation-match-text">{{disease}}</span>
    <span *ngIf="curationTier != null && curationTier !=''" class="tier rectangle-{{curationTier}}">Tier {{curationTier}}</span>
    <div class="curation-status1-oval1 {{status}}"></div>
    <span class="curation-match-text-status">{{statusText}}</span>
    <span class="curation-match-text">{{lastModificationDate}}</span>
</div>

